import {Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {CommonHelper} from '../../../shared/helpers/CommonHelper';
import {DropDownList} from '../../../models/DropDownList.model';
import { Json2csvService } from "../../../services/json2csv.service";
import { GUARDS } from '../../../shared/auth/Roles';
import {ToastsManager} from 'ng2-toastr';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { kenobyConsultantService } from '../../../services/kenobyConsultants.service';
import { KenobyConsultantSearch } from '../../../models/kenobyConsultantSearch.model';
import { KenobyConsultant } from '../../../models/KenobyConsultant.model';
import * as _ from 'lodash';
import * as moment from 'moment';


import { Router } from '@angular/router';

@Component({
    selector: 'app-consultants-kenoby',
    templateUrl: './consultants-kenoby.component.html',
    styleUrls: ['./consultants-kenoby.component.scss']
})
export class ConsultantsKenobyComponent implements OnInit {
    @ViewChild("buttonModalDeclined") buttonModalDeclined: ElementRef;
    dropDownListDivisions: DropDownList[] = new Array<DropDownList>();
    selectedDivisionsItems: DropDownList[] = new Array<DropDownList>();
    dropDownDivisionsSettings = {};

    selectedStatusItems: DropDownList[] = new Array<DropDownList>();
    dropDownListStatus: DropDownList[] = new Array<DropDownList>();
    dropDownStatusSettings = {};

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;

    consultants: KenobyConsultant[] = new Array<KenobyConsultant>();
    consultantsExport: KenobyConsultant[] = new Array<KenobyConsultant>();
    consultantAux: KenobyConsultant = new KenobyConsultant();

    commonHelper: CommonHelper = new CommonHelper();
    consultantSearchModel: KenobyConsultantSearch = new KenobyConsultantSearch();
    publicDataForm: FormGroup;
    newData: number;
    user;
    loading: boolean;
    typeContractAux: string = '';
    GUARDS = GUARDS;
    isDP: boolean = false;

    constructor(private kenobyConsultantService: kenobyConsultantService,
                private json2csvService: Json2csvService,
                private toastr: ToastsManager,
                private router: Router,
                private errorHandler: ErrorHandlerProvider) {
    }

   async ngOnInit() {
        this.loading = true;
        this.consultantSearchModel = new KenobyConsultantSearch();
        this.dropDownListDivisions = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllGroups(), "GroupDivision");
        this.dropDownDivisionsSettings = this.commonHelper.getDropDownSettings(false, 'Divisões', false, 'Marcar todas as divisões', 'Desmarcar todas as divisões', false,null, '');

        this.dropDownListStatus = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllStatusKenoby(), "StatusKenoby");
        this.dropDownStatusSettings = this.commonHelper.getDropDownSettings(true, 'Status', false, 'Marcar todas os status', 'Desmarcar todos os status', false,null, '');
        await this.searchConsultants(1);
        
        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchConsultants(1);
        }
    }


    async searchConsultants(page?: number, toexport?: boolean) {
        try {
            let limit;
            this.loading = true;
            this.currentPage = page ? page : 1;
            this.consultantSearchModel.skip = (this.currentPage - 1) * this.consultantSearchModel.limit;
            if (toexport) {
                limit = this.consultantSearchModel.limit;
                this.consultantSearchModel.skip = 0;
                delete this.consultantSearchModel.limit;
            }

            this.consultantSearchModel.division = [];
            this.consultantSearchModel.status = [];
            for (let d of this.selectedStatusItems)
                this.consultantSearchModel.status.push(parseInt(d.id));
            for (let d of this.selectedDivisionsItems)
                this.consultantSearchModel.division.push(parseInt(d.id));

            if(toexport){
                this.consultantsExport = await this.kenobyConsultantService.searchConsultants(this.consultantSearchModel);
                this.consultantSearchModel.limit = limit;
            } else {
                this.consultants = await this.kenobyConsultantService.searchConsultants(this.consultantSearchModel);
                this.totalItems = this.consultantSearchModel.totalItems;
            }

            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.errorHandler.interceptError(error, 'Kenoby');
        }
    }

    async removeKenoby(){
        try {
            const response = await this.kenobyConsultantService.removeKenoby(this.consultantAux._id);

            if(response.success){
                this.toastr.success('Consultor excluido com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Kenoby');
            }
            await this.searchConsultants(1);
            this.clear();
        } catch(err){
            console.log(err)
            this.errorHandler.interceptError(err, 'Kenoby');
            this.clear();
        }
    };

    finishRegistration(id) {
        this.router.navigate(["/consultants/new"], { queryParams: { kenoby: true, id } });
    }

    async export() {
        await this.searchConsultants(1, true);

        this.json2csvService.export(
            this.consultantsExport.map(kenobyShow => {
                return {
                    "Nome": kenobyShow.name ? kenobyShow.name : "-",
                    "Cidade": kenobyShow.city ? kenobyShow.city : "-",
                    "Estado": kenobyShow.state ? kenobyShow.state : "-",
                    "Sexo": kenobyShow.gender ? (kenobyShow.gender == 1 ? 'Feminino' : (kenobyShow.gender == 2 ? "Masculino":'-')) : '-',
                    "Telefone": this.transcriptPhone(kenobyShow),
                    "Data de Nascimento":kenobyShow.born ? moment(kenobyShow.born).format("DD/MM/YYYY") : "-",
                    "E-mail": kenobyShow.email ? kenobyShow.email : "-",
                    "Cargo": kenobyShow.position ? kenobyShow.position : "-",
                    "Skills": kenobyShow.skills&&kenobyShow.skills.length>0?kenobyShow.skills.map(sk => sk.name).join(', '):"-",
                    "Status": kenobyShow.status ? this.commonHelper.transcriptStatusKenoby(kenobyShow.status):"-"
                    };
            }),
            `Contratados Kenoby - ${new Date().toLocaleDateString('pt-br')}`
        );
    }

    transcriptPhone(c) {
        let phones = [];
        if(c.cellPhone) phones.push(c.cellPhone);
        if(c.homePhone) phones.push(c.homePhone);
        return phones.join(' / ');
    }

    openModalDeclined(consultant: any){
        this.consultantAux = new KenobyConsultant();
        this.consultantAux = { ...consultant };
        this.buttonModalDeclined.nativeElement.click();
    }

    async clear(){
        this.consultantAux = new KenobyConsultant();
    }

}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultants-kenoby/consultants-kenoby.component.ts